module.exports = __webpack_public_path__ + "img/list1 (4).038335ab.png";